module.exports = __webpack_public_path__ + "img/tran_touch.aebd868d.png";